/* @flow */
export const ANALYSIS_ENDPOINT = '/services/constellation/analysis';

export type Options = {
  sortBy?: string,
  sortOrder?: 'ASC' | 'DESC',
};



// WEBPACK FOOTER //
// ./src/app/modules/analysis/constants.js